export enum LocalStorageKeys {
    APP_VERSION = 'version',
    SAVED_USERNAME = 'persist-savedUsername',
    MENU_ITEM = 'menuItem',
    USER_INFO = 'userInfo',
    ENVIRONMENT = 'environment',
    ACCESS_TOKEN = 'accessToken',
    REFRESH_TOKEN = 'refreshToken',
    IS_EMPLOYEE = 'persist-isEmployee',
    CONSOLE_LOG_INFO_ENABLED = 'isConsoleInfoEnabled',
    CONSOLE_LOG_INCLUDE_TRACE = 'isConsoleTraceEnabled',
    SHOW_ACCESS_TOKEN_EXPIRATION = 'showAccessTokenExpiration',
    SHOW_REQUEST_QUEUE_TEST_TOGGLE = 'showRequestQueueTestToggle',
    IS_REFRESHING_SESSION = 'isRefreshingSession',
    IS_LOGGING_IN = 'isLoggingIn',

    FILTER_AUDIT_NOTES_LIST = 'auditNotesListFilter',
}



// WEBPACK FOOTER //
// ./src/app/core/constants/localStorageKeys.enum.ts